import "@/App.css";
import { BrowserRouter, Routes, Route, Outlet, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Toaster } from "@/components/ui/sonner";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Events from "@/pages/Events";
import Gallery from "@/pages/Gallery";
import GetInvolved from "@/pages/GetInvolved";
import Donate from "@/pages/Donate";
import GalleryManage from "@/pages/GalleryManage";

function ScrollTop() {
  const { pathname } = useLocation();
  useEffect(() => window.scrollTo(0, 0), [pathname]);
  return null;
}

function Layout() {
  return (
    <>
      <ScrollTop />
      <Navbar />
      <main className="min-h-screen">
        <Outlet />
      </main>
      <Footer />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/about_us" element={<About />} />
            <Route path="/calendar" element={<Events />} />
            <Route path="/media" element={<Gallery />} />
            <Route path="/partnerships" element={<GetInvolved />} />
            <Route path="/donate" element={<Donate />} />
          </Route>
          <Route path="/gallery-manage" element={<GalleryManage />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
